/**
 * Query keys for the campaign-service reads. The keys exist so two hooks
 * reading the same endpoint share one cache entry rather than firing twice.
 * The one invalidation surface is `officeDiscountHistory`, which the office
 * apply/remove promo-code mutations refresh (GOTU-9821).
 */
export const campaignsKeys = {
  all: ['campaigns'],
  /** The whole discount-campaign set the Promo Codes page pages client-side. */
  promoCodes: () => ['campaigns', 'promo-codes'],
  promoCode: (campaignId) => ['campaigns', 'promo-code', campaignId],
  promoCodeReport: (campaignId) => ['campaigns', 'promo-code', campaignId, 'report'],
  /** One page of the offices a code's rule names, per search term. */
  promoCodeTargetOffices: (campaignId, search, page) => [
    'campaigns', 'promo-code', campaignId, 'target-offices', { search, page },
  ],
  officeDiscountHistory: (officeId) => ['campaigns', 'office', officeId, 'discounts'],
  professionalCampaigns: (professionalId) => ['campaigns', 'professional', professionalId],
};
